import React from 'react'
import { appleStore_img, playStore_img, chevronsDown } from "../../assets"

function Header({ data, smScreen }) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;


    const playStoreButton = (linkData) => {
        const link = (/android/i.test(userAgent)) ? linkData.mobile : linkData.desktop;
        console.log(link)
        if (link === "")
            return null;
        return <button onClick={() => window.open(link, "_blank")} className="btn playstore">
                    <img src={playStore_img} alt="Get it on google play"/>
                </button>;
    }

    const appleStoreButton = (linkData) => {
        const link = (/Mac OS/i.test(userAgent)) ? linkData.mobile : linkData.desktop;
        console.log(link)
        if (link === "")
            return null;
        return <button onClick={() => window.open(link, "_blank")} className="btn applestore">
                    <img src={appleStore_img} alt="Download on the App Store"/>
                </button>;
    }

    return (
        <header id="header" className="container-fluid" style={{background: `url(${data.backgound.URL})`} }>
            <h2>{ data.title }</h2>
            <p>{ data.description }</p>
            <div className="downloadLinks">
                {appleStoreButton(data.download.appleStoreLink)}
                {playStoreButton(data.download.playStoreLink)}
            </div>
            <span className="go__down" onClick={() => { console.log(document.querySelector('#about'));window.scrollTo(0, document.querySelector('#about').offsetTop - 25)}}>
                <img src={chevronsDown} alt="go down"/>
            </span>
        </header>
    )
}

export default Header
